import { Spin } from 'antd';

import InlineStyled from '../InlineStyled/InlineStyled';

const Loader = ({ style = {}, spinSize = 'small' }) => {
  return (
    <InlineStyled
      $style={{
        display: 'grid',
        placeItems: 'center',
        height: '100%',
        width: '100%',
        ...style,
      }}
    >
      <Spin size={spinSize} />
    </InlineStyled>
  );
};

export default Loader;
